import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, DEFINITION_KINDS, define } from '../types.js';

/**
 * Batch grouping for multi-vehicle orders.
 *
 * @remarks
 * System-managed object set during move creation from Super Dispatch multi-vehicle
 * orders. Groups moves together for tracking and status synchronization.
 *
 * Properties:
 * - `order_ref`: External reference ID from Super Dispatch
 * - `size`: Number of vehicles in the batch
 */
export const schema = z
  .object({
    order_ref: z.string().describe('External order reference from Super Dispatch').optional(),
    size: z.number().int().positive().describe('Number of vehicles in this batch').optional(),
  })
  .strict()
  .optional();

export type Batch = z.infer<typeof schema>;

export const definition = define({
  key: 'batch',
  schema,
  label: 'Batch',
  description:
    'Groups moves from multi-vehicle Super Dispatch orders. Contains order reference and batch size. Set by integrations, not user-configurable.',
  kind: DEFINITION_KINDS.OUTPUT,
  category: CATEGORIES.OPERATIONAL_STATE.key,
  writableAtLevels: [LEVELS.MOVE],
  readableByRoles: [ROLES.ADMIN],
});
